import i18n from 'i18n'
import { BonusWalletStatusType } from '@/enums'

/**
 * Defines the list of statuses for the wallets,
 * used in the bonus wallet component.
 */
export const WalletsStatusLabels = {
  [BonusWalletStatusType.ACTIVE]: {
    label: i18n.t('wallet.walletStatusType.ACTIVE'),
    color: 'green',
  },
  [BonusWalletStatusType.RELEASED]: {
    label: i18n.t('wallet.walletStatusType.RELEASED'),
    color: 'blue',
  },
  [BonusWalletStatusType.USEDUP]: {
    label: i18n.t('wallet.walletStatusType.USEDUP'),
    color: 'blue',
  },
  [BonusWalletStatusType.CANCELED]: {
    label: i18n.t('wallet.walletStatusType.CANCELED'),
    color: 'red',
  },
  [BonusWalletStatusType.EXPIRED]: {
    label: i18n.t('wallet.walletStatusType.EXPIRED'),
    color: 'blue',
  },
}
